import CWLoader from 'components/CWLoader/CWLoader'
import Drawer from 'components/Drawer'
import Form from 'components/Form/Form'
import { Formik } from 'formik'
import { FormattedMessage, useIntl } from 'react-intl'
import Button from 'ui/Button'
import { LinkedMetricState } from 'utils/types/metricsV2'
import { LoaderWrapper } from '../EditMetric.styles'
import EditInvestorMetricForm from './EditInvestorMetricForm'
import useEditInvestorMetric, {
  EditInvestorMetricFormType,
} from './useEditInvestorMetric'

interface Props {
  isOpen: boolean
  closeDrawer: () => void
}

const EditInvestorMetric = ({ closeDrawer, isOpen }: Props) => {
  const intl = useIntl()
  const {
    initialValues,
    isLoading,
    isEditingMetric,
    metric,
    validationSchema,
    editMetricMutation,
  } = useEditInvestorMetric({
    closeDrawer,
  })

  if (isLoading || !initialValues || !metric) {
    return (
      <LoaderWrapper>
        <CWLoader />
      </LoaderWrapper>
    )
  }

  const showFounderTimelineItem =
    metric.receiverMetricLink?.state === LinkedMetricState.REQUEST_ACCEPTED ||
    metric.receiverMetricLink?.state === LinkedMetricState.SHARE_ACCEPTED
  const showTimelineMessage = !!metric?.receiverMetricLink?.message
  const showTimeline = showFounderTimelineItem || showTimelineMessage

  return (
    <Drawer
      isOpen={isOpen}
      headerTitle={`${metric?.name} ${intl.formatMessage({
        id: 'metrics.settings',
      })}`}
      onCloseDrawer={closeDrawer}
    >
      <Formik
        initialValues={initialValues}
        onSubmit={(values) => editMetricMutation(values)}
        validationSchema={validationSchema}
        validateOnMount
      >
        {({ submitForm, isValid }) => (
          <Form<EditInvestorMetricFormType> {...initialValues!}>
            <Drawer.Content contentPadding="2rem 2.4rem">
              <EditInvestorMetricForm
                showFounderTimelineItem={showFounderTimelineItem}
                showTimelineMessage={showTimelineMessage}
                showTimeline={showTimeline}
                metric={metric}
              />
            </Drawer.Content>

            <Drawer.Footer>
              <Button
                secondary
                type="button"
                onClick={closeDrawer}
                disabled={isEditingMetric}
              >
                <FormattedMessage id="metrics.cancel" />
              </Button>

              <Button
                primary
                type="submit"
                disabled={!isValid || isEditingMetric}
                onClick={submitForm}
              >
                <FormattedMessage id="metrics.save" />
              </Button>
            </Drawer.Footer>
          </Form>
        )}
      </Formik>
    </Drawer>
  )
}

export default EditInvestorMetric
